module.exports = __webpack_public_path__ + "static/Emorial-2bd25d118182140bd0704945a638b5fc.png";